import React from 'react'
import PropTypes from 'prop-types'

import NewsList from './NewsList'
import LatestNewsQuery from './LatestNewsQuery'

const RecentNews = ({excludeArticleSlug, ...props}) => <LatestNewsQuery
	excludeArticleSlug={excludeArticleSlug}
	limit={3}>
	{({articles}) => <NewsList {...props} items={articles}/>}
</LatestNewsQuery>

RecentNews.propTypes = {
	className: PropTypes.string,
	excludeArticleSlug: PropTypes.string.isRequired,
}

RecentNews.defaultProps = {
	className: '',
}

export default RecentNews
